import React, { useEffect } from "react";

const AuthRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  ...props
}) => {
  useEffect(() => {
    const isBlank = blankLayout ? true : false;
  }, [blankLayout]);

  return <Component {...props} />
};

export default AuthRoute;
